import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkFilterBar, SkTable } from './_primitives';

/** IntegrationsPage — header, stats, 3+ tabs (integrations/sync-history/providers), table */
const IntegrationsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={3} />
      <SkFilterBar filters={2} withButton />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default IntegrationsPageLoader;
